/**
 * A person at a client company.
 *
 * Only `name` is required: an admin often has a name and a title from a phone
 * call and nothing else.
 *
 * `receivesBid` may be set on any number of contacts, since the bid is our own
 * templated email. `receivesInvoice` may be set on at most one, because Stripe
 * emails an invoice to the customer's address and has no per invoice recipient.
 * Either flag requires an email.
 */
export interface ContactDTO {
  /** Absent for a row the admin has just added and not yet saved. */
  id?: string;
  name: string;
  title?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  receivesBid: boolean;
  receivesInvoice: boolean;
}

export function emptyContact(): ContactDTO {
  return {
    name: "",
    title: "",
    email: "",
    phoneNumber: "",
    receivesBid: false,
    receivesInvoice: false,
  };
}
